export const search = async (term) => {
    const response = await fetch(`azure/members?name=${term}`);
    return await response.json();
};

export default {
    search
};
